import React, {useState} from "react";
import {AccessibilityNew, ArrowDropDown, Check} from "@mui/icons-material";
import {Button, IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import Badge from "@mui/material/Badge";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {isA11ySelector} from "../../state/app/appSelectors";
import {HEADER_BUTTON_VIEW_MODE_ICON, HEADER_BUTTON_VIEW_MODE_ICONTEXT} from "../header/utils";

const A11yIcon = ({isA11y}) => (
  <Badge
    showZero
    color="secondary"
    overlap="rectangular"
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right"
    }}
    badgeContent={isA11y ? <Check sx={{fontSize: "12px"}} /> : undefined}
    slotProps={{
      badge: {
        sx: {
          padding: "0px",
          width: "12px",
          height: "12px",
          minWidth: "0px",
          backgroundColor: theme => theme.palette.success.main
        }
      }
    }}
  >
    <AccessibilityNew fontSize="small" />
  </Badge>
);

const A11ySelect = ({viewMode}) => {
  const {t} = useTranslation();

  let [, setSearchParams] = useSearchParams();

  const isA11y = useSelector(isA11ySelector);

  const [anchorEl, setanchorEl] = useState(null);
  const handleOpen = event => {
    setanchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setanchorEl(null);
  };

  return (
    <>
      <Tooltip title={isA11y ? t("components.a11ySelect.enable.title") : t("components.a11ySelect.disable.title")}>
        {viewMode === HEADER_BUTTON_VIEW_MODE_ICON ? (
          <IconButton
            onClick={handleOpen}
            aria-label={
              isA11y ? t("components.a11ySelect.enable.ariaLabel") : t("components.a11ySelect.disable.ariaLabel")
            }
            color="inherit"
          >
            <A11yIcon isA11y={isA11y} />
          </IconButton>
        ) : (
          <Button
            onClick={handleOpen}
            startIcon={viewMode === HEADER_BUTTON_VIEW_MODE_ICONTEXT ? <A11yIcon isA11y={isA11y} /> : null}
            endIcon={<ArrowDropDown />}
            aria-label={
              isA11y ? t("components.a11ySelect.enable.ariaLabel") : t("components.a11ySelect.disable.ariaLabel")
            }
            classes={{
              endIcon: "button-select__menu-button__end-icon"
            }}
            sx={{
              background: Boolean(anchorEl) ? "#f5f5f5" : undefined
            }}
          >
            {isA11y ? t("components.a11ySelect.enable.label") : t("components.a11ySelect.disable.label")}
          </Button>
        )}
      </Tooltip>

      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          key="a11yEnable"
          id="a11y-select__enable-btn"
          onClick={() => {
            setSearchParams(prev => {
              const next = new URLSearchParams(prev);
              next.set("accessible", "true");
              return next;
            });
            handleClose();
          }}
        >
          {t("components.a11ySelect.menuItems.enable")}
        </MenuItem>
        <MenuItem
          key="a11yDisable"
          id="a11y-select__disable-btn"
          onClick={() => {
            setSearchParams(prev => {
              const next = new URLSearchParams(prev);
              next.delete("accessible");
              return next;
            });
            handleClose();
          }}
        >
          {t("components.a11ySelect.menuItems.disable")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default A11ySelect;
